exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuActiveText": "#0c8aff",
	"menuColor": "#fff",
	"menuLightColor": "#fff",
	"menuColorActive": "#f4f4f5",
	"menuBackground": "#001529",
	"menuLightBackground": "#2b68c9",
	"subMenuBackground": "#1f2d3d",
	"subMenuHover": "#001528",
	"sideBarWidth": "200px",
	"logoTitleColor": "#fff",
	"logoLightTitleColor": "#001529"
};